import { InjectionToken } from '@angular/core';
import type { RedirectTracingService } from './redirect.tracing';

export const REDIRECT_TRACING_SERVICE = new InjectionToken<RedirectTracingService>('RedirectTracingService');
